import * as React from "react";

// NOTE: This hook was extracted because document title setting is used in multiple
// places (EditorApp, AuthenticatedUserRequiredRoute, SharePageTemplateLayout) and
// each needs the same dev mode suffix logic. Centralizing here avoids duplication.
export function useDocumentTitle(title: string | null | undefined) {
  React.useEffect(() => {
    if (title) {
      const modeSuffix =
        window.__BUILD_MODE__ === "development"
          ? " - Replo Dev Mode"
          : " - Replo";
      document.title = `${title}${modeSuffix}`;
    }
  }, [title]);
}
